import { useState, useEffect } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let supplierDateOptions = [];
let defaultSupplierDateOptions = [];
const SupplierLocationReadOnlyRow = ({ key, t, supplierDates, partnerLocationItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [partnerNumber, setPartnerNumber] = useState(partnerLocationItem.partnerNumber);
    const [isEditMode, setIsEditMode] = useState(false);
    const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);
	
	useEffect(() => {
		 setSupplierDates(supplierDates);
	}, []);
	
	function setSupplierDates(supplierDateList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        defaultSupplierDateOptions = [];
        if (supplierDateList && supplierDateList.length > 0) {
            supplierDateList.map((aSupplierDate, idx) => {
				supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
				 if (partnerLocationItem.supplierDates && partnerLocationItem.supplierDates.length > 0) {
            		partnerLocationItem.supplierDates.map((eachSupplierDate) => {
						if(aSupplierDate.partnershipDateKey == eachSupplierDate.partnershipDateKey){
							defaultSupplierDateOptions.push(supplierDateValue);
							return null;
						}
				 	});
				 }
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
            setSupplierDatesSelected(defaultSupplierDateOptions);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
        setSupplierDatesSelected(selectedOptions);
    }
	
    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, partnerLocationItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, partnerLocationItem, submitComplete);
    }

    function changePartnerNumber(newPartnerNumber) {
        let partnerNameRegEx = /^[a-zA-Z0-9_-]+$/;
        if (newPartnerNumber) {
            if (!partnerNameRegEx.test(newPartnerNumber)) {
                errors.push(t("error.partnerNumber.invalid"));
                setPartnerNumber(partnerLocationItem.partnerNumber);
            } else {
                setPartnerNumber(newPartnerNumber);
            }
        }
    }

    function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        setIsSubmit(false);
        setIsEditMode(true);
        setSupplierDates(supplierDates);
    }

    function submitUpdate(event, partnerLocationItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let updatedValues = {
            locationKey: partnerLocationItem.locationKey,
            partnerNumber: partnerNumber,
            partnershipDateKeys: supplierDatesSelected.map(option => option.value),
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }

    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }

    function submitCancel(event, partnerLocationItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setPartnerNumber(partnerLocationItem.partnerNumber);
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={key}>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.departmentName}</td>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.locationName}</td>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.address}</td>
            {isEditMode ? (
                <>
                    <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
                        <input
                            type="text"
                            name="partnerNumber"
                            id="partnerNumber"
                            value={partnerNumber}
                            onChange={(e) => changePartnerNumber(e.target.value)}
                            maxLength="50"
                            placeholder={t("page.suplrNumber")}
                            className="form-control rounded-pill shadow-sm px-4 "
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
		                {supplierDateLoaded ? <Select
		                    name="supplierDateKey"
		                    options={supplierDateOptions}
		                    onChange={supplierDateHandler}
		                    placeholder={""}
		                    value={supplierDatesSelected}
		                    isSearchable={true}
		                    isClearable={true}
		                    className="myselect"
		                    inputId="supplierDateKey-input"
		                    isMulti
		                    styles={ddStyles}
		                />
	                    : <></>}
                	</td>
                </>
            ) : (
                <>
                    <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.partnerNumber}</td>
                    <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.supplierDateString}</td>
                </>
            )
            }
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerLocationItem.status}</td>
            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => submitUpdate(event, partnerLocationItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"}
                            onClick={(event) => (submitCancel(event, partnerLocationItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, partnerLocationItem)}>
                            {partnerLocationItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}
            </td>
        </tr>
    )
}
export default SupplierLocationReadOnlyRow;